import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import SelectAllChecksGroup from '../../../../../reusable/Form/SelectAllChecksGroup.jsx';
import { LANGUAGE_SELECT_OPTIONS } from './../../../../../constants';
import { forIn } from 'lodash';

class LanguageFilter extends Component {

    static propTypes = {
        languages: PropTypes.object,
        switchLanguage: PropTypes.func
    }

    static defaultProps = {
        languages: {
            "en-us": true
        }
    }

    constructor(props) {
        super(props);

        this.filterByLanguage = this.filterByLanguage.bind(this);
    }

    filterByLanguage(options) {
        let newLanguage = Object.assign({}, this.props.languages);

        for (let i in options) {
            newLanguage[options[i].name] = options[i].value
        }

        this.props.switchLanguage(newLanguage);
    };

    render() {
        let options = []
        forIn(this.props.languages, (value, key) => {
                options.push({
                    label: this.props.intl.formatMessage({ id: LANGUAGE_SELECT_OPTIONS[key] }),
                    value: value,
                    name: key
                });
            }
        );
        return <SelectAllChecksGroup value={this.props.languages}
                                     onChange={this.filterByLanguage}
                                     options={options}
                                     selectAll={this.props.intl.formatMessage({ id: "Dashboard_CoreFunctionality_UIText_dashboard.selectAll" })}
                                     classNames="notranslate risk-levels-filter"/>

    }

}

export default injectIntl(LanguageFilter);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/FilterPod/Language.filter.jsx